import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import MainLayout from './components/layouts/MainLayout.jsx';
import Login from './pages/Login.jsx';
import Forbidden from './pages/Forbidden.jsx';
import NotFound from './pages/NotFound.jsx';
import DefaultPage from './pages/DefaultPage.jsx';
import SystemSetupAndMasterDataPage from './pages/system-administration-and-master-data/system-setup-and-master-data-page/SystemSetupAndMasterDataPage.jsx';
import MasterRecipeAndCostedBomPage from './pages/recipe-and-bill-of-materials-repository/master-recipe-and-costed-bom-repository-page/MasterRecipeAndCostedBomPage.jsx';
import BrandCostAllocationReportPage from './pages/recipe-and-bill-of-materials-repository/brand-cost-allocation-report-page/BrandCostAllocationReportPage.jsx';
import SystemActivityLogPage from './pages/notifications-&-audit/system-activity-log-page/SystemActivityLogPage.jsx';
import InventoryAlertDigestSettingsPage from './pages/notifications-&-audit/inventory-alert-digest-settings-page/InventoryAlertDigestSettingsPage.jsx';
import PullOrderEntryAndStatusPage from './pages/brand-pull-order-management/pull-order-entry-and-status-page/PullOrderEntryAndStatusPage.jsx';
import ConsolidatedDemandDashboardPage from './pages/brand-pull-order-management/consolidated-demand-dashboard-page/ConsolidatedDemandDashboardPage.jsx';
import ProductionScheduleAndSlotCalendarPage from './pages/production-schedule-&-kitchen-slot-booking/production-schedule-&-slot-calendar-page/ProductionScheduleAndSlotCalendarPage.jsx';
import RawMaterialReceiptAndStockLedgerPage from './pages/raw-material-inventory/raw-material-receipt-&-stock-ledger-page/RawMaterialReceiptAndStockLedgerPage.jsx';
import TransferDispatchAndReceiptPage from './pages/transfer-&-delivery-tracker/transfer-dispatch-&-receipt-page/TransferDispatchAndReceiptPage.jsx';
import { DEFAULT_ROUTE, registerRoute } from './utils/menuConfig.js';
import { ROLES } from './utils/roles.js';
import { PAGE_REGISTRY } from './utils/pageRoutes.js';

// Register every UC page wired below so post-login redirect knows whether the
// Design Studio default page is available.
registerRoute(PAGE_REGISTRY[72454].route); // UC 34267 — System Setup & Master Data
registerRoute(PAGE_REGISTRY[72451].route); // UC 34264 — Master Recipe & Costed BOM
registerRoute(PAGE_REGISTRY[72447].route); // UC 34255 — Pull Order Entry & Status
registerRoute(PAGE_REGISTRY[72449].route); // UC 34258 — Consolidated Demand Dashboard
registerRoute(PAGE_REGISTRY[72448].route); // UC 34260/34256 — Production Schedule & Slot Calendar
registerRoute(PAGE_REGISTRY[72450].route); // UC 34259 — Raw Material Receipt & Stock Ledger
registerRoute(PAGE_REGISTRY[72452].route); // UC 34261/34262 — Transfer Dispatch & Receipt
registerRoute(PAGE_REGISTRY[72455].route); // UC 34266 — Brand Cost Allocation Report
registerRoute(PAGE_REGISTRY[72456].route); // UC 34268 — System Activity Log
registerRoute(PAGE_REGISTRY[72453].route); // UC 34269/34270 — Inventory Alert Digest

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forbidden" element={<Forbidden />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          {/* Root redirect: send authenticated users to the Design Studio
              DefaultMenuItem route. Until that page is wired in we land on
              /dashboard which renders the holding DefaultPage. */}
          {/* Until UC pages are converted, send everyone to /dashboard. Once
              the DEFAULT_ROUTE page (Pull Order Entry & Status) is wired in,
              swap this redirect target to {DEFAULT_ROUTE}. */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DefaultPage />} />

          {/* UC 34267 — System Setup & Master Data (SuperAdmin + Finance only) */}
          <Route element={<ProtectedRoute roles={[ROLES.SUPER_ADMIN, ROLES.FINANCE]} />}>
            <Route
              path={PAGE_REGISTRY[72454].route}
              element={<SystemSetupAndMasterDataPage />}
            />
            {/* UC 34264 — Master Recipe & Costed BOM (same role gate) */}
            <Route
              path={PAGE_REGISTRY[72451].route}
              element={<MasterRecipeAndCostedBomPage />}
            />
          </Route>

          {/* UC 34255 — Pull Order Entry & Status (all authenticated roles) */}
          <Route
            path={PAGE_REGISTRY[72447].route}
            element={<PullOrderEntryAndStatusPage />}
          />

          {/* UC 34258 — Consolidated Demand Dashboard (all authenticated roles) */}
          <Route
            path={PAGE_REGISTRY[72449].route}
            element={<ConsolidatedDemandDashboardPage />}
          />

          {/* UC 34260/34256 — Production Schedule & Slot Calendar (all authenticated roles) */}
          <Route
            path={PAGE_REGISTRY[72448].route}
            element={<ProductionScheduleAndSlotCalendarPage />}
          />

          {/* UC 34259 — Raw Material Receipt & Stock Ledger (all authenticated roles) */}
          <Route
            path={PAGE_REGISTRY[72450].route}
            element={<RawMaterialReceiptAndStockLedgerPage />}
          />

          {/* UC 34261/34262 — Transfer Dispatch & Receipt (all authenticated roles) */}
          <Route
            path={PAGE_REGISTRY[72452].route}
            element={<TransferDispatchAndReceiptPage />}
          />

          {/* UC 34266 — Brand Cost Allocation Report (Super Admin / Finance) */}
          <Route
            path={PAGE_REGISTRY[72455].route}
            element={<BrandCostAllocationReportPage />}
          />

          {/* UC 34268 — System Activity Log (Super Admin / Finance) */}
          <Route
            path={PAGE_REGISTRY[72456].route}
            element={<SystemActivityLogPage />}
          />

          {/* UC 34269/34270 — Inventory Alert Digest (Commissary Supervisor + Procurement Staff) */}
          <Route
            path={PAGE_REGISTRY[72453].route}
            element={<InventoryAlertDigestSettingsPage />}
          />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
